const jobs = [
    {
        active: true,
        archived: false,
        businessUnit: "Head Office",
        category: "Product",
        categorySlug: "product",
        remote: "remote",
        summary: {
            en: "A short summary of the role to provide a brief overview for preview links and search results.",
        },
        content: {
            en: `
            <p>
              [Company Name] is a dynamic and innovative [industry/sector] company dedicated to delivering cutting-edge solutions
              to our clients.
            </p>

            <p>
              We specialize in [briefly describe the industry or sector focus and the types of products/services offered]. Our
              commitment to excellence has made us a leader in our field, and we are seeking a Senior Integrations Manager to join
              our team and drive seamless integrations across our technology stack.
            </p>

            <h3>Position Overview:</h3>
            <p>
              As the Senior Integrations Manager at [Company Name], you will play a pivotal role in ensuring that our systems,
              applications, and platforms work seamlessly together to deliver exceptional value to our clients. You will lead a
              talented team of integration specialists and collaborate with cross-functional teams to design, implement, and
              optimize integrations that enhance the efficiency and effectiveness of our operations.
            </p>

            <h3>Key Responsibilities:</h3>
            <ul>
              <li>
                <strong>Integration Strategy:</strong> Develop and execute a comprehensive integration strategy that aligns with
                the company's goals and objectives, driving efficiency and innovation.
              </li>
              <li>
                <strong>Team Leadership:</strong> Lead and mentor a team of integration specialists, providing guidance, support,
                and expertise in integration best practices.
              </li>
              <li>
                <strong>System Integration:</strong> Oversee the design, development, and maintenance of integrations between
                various systems, including [list key systems/platforms relevant to the role].
              </li>
              <li>
                <strong>Stakeholder Collaboration:</strong> Collaborate with internal teams, including IT, product development,
                sales, and customer support, to identify integration needs and prioritize projects.
              </li>
              <li>
                <strong>Vendor Relations:</strong> Manage relationships with external vendors and partners to ensure successful
                third-party integrations and the timely resolution of any integration-related issues.
              </li>
              <li>
                <strong>Quality Assurance:</strong> Establish and enforce integration testing processes to ensure data accuracy,
                system reliability, and security.
              </li>
              <li>
                <strong>Documentation:</strong> Maintain detailed documentation of integration processes, configurations, and
                troubleshooting procedures.
              </li>
              <li>
                <strong>Continuous Improvement:</strong> Stay current with industry trends and emerging technologies related to
                integrations, proactively seeking opportunities to improve and optimize existing integrations.
              </li>
            </ul>

            <h3>Qualifications:</h3>
            <ul>
              <li>
                Bachelor's degree in Computer Science, Information Technology, or a related field; Master's degree is a plus.
              </li>
              <li>Proven experience in integration management, preferably in [mention relevant industry or sector].</li>
              <li>Strong leadership and team management skills.</li>
              <li>Deep technical knowledge of integration tools, APIs, and protocols.</li>
              <li>Excellent problem-solving and troubleshooting abilities.</li>
              <li>
                Effective communication skills with the ability to translate technical concepts to non-technical stakeholders.
              </li>
              <li>Project management experience and familiarity with project management tools and methodologies.</li>
              <li>Strong organizational skills and attention to detail.</li>
            </ul>

            <h3>Why [Company Name]?</h3>
            <ul>
              <li>Opportunity to lead integration initiatives at a dynamic and growing [industry/sector] company.</li>
              <li>Competitive salary and benefits package.</li>
              <li>Collaborative and innovative work environment.</li>
              <li>Opportunity for professional growth and development.</li>
            </ul>

            <p>
              If you are a skilled Integrations Manager with a passion for creating efficient, interconnected systems, we invite
              you to apply for the role of Senior Integrations Manager at [Company Name]. Join us in driving innovation and
              delivering exceptional value to our clients through seamless integrations.
            </p>
          `,
        },
        createdAt: new Date(),
        geo: [-0.7594171, 52.0406224],
        location: "Milton Keynes",
        locationLabel: "Milton Keynes",
        locationMeta: {
            address_components: [
                {
                    long_name: "Milton Keynes",
                    short_name: "Milton Keynes",
                    types: ["locality", "political"],
                },
                {
                    long_name: "Milton Keynes",
                    short_name: "Milton Keynes",
                    types: ["postal_town"],
                },
                {
                    long_name: "Milton Keynes",
                    short_name: "Milton Keynes",
                    types: ["administrative_area_level_2", "political"],
                },
                {
                    long_name: "England",
                    short_name: "England",
                    types: ["administrative_area_level_1", "political"],
                },
                {
                    long_name: "United Kingdom",
                    short_name: "GB",
                    types: ["country", "political"],
                },
            ],
            formatted_address: "Milton Keynes, UK",
            place_id: "ChIJhYYjgvhMdkgRFH65TPedGhY",
        },
        published: true,
        reference: "JOB-1",
        showOnGoogleJobs: true,
        slug: "2d43f697-bae6-4b30-8f9b-d45a16060935-test-integration-manager-job",
        tags: ["integrations"],
        title: "Integration Manager",
        type: "Full Time",
        updatedAt: new Date(),
        salary: {
            type: "Annual",
            from: 50000,
            to: 60000,
            currency: "GBP",
        },
    },
    {
        active: true,
        archived: false,
        businessUnit: "Head Office",
        category: "Marketing",
        categorySlug: "marketing",
        remote: "hybrid",
        summary: {
            en: "A short summary of the role to provide a brief overview for preview links and search results.",
        },
        content: {
            en: `
            <p>
                As a Marketing Executive at [Company Name], you will play a crucial role in developing and executing marketing
                strategies to drive brand awareness, customer engagement, and business growth. You will collaborate with
                cross-functional teams and leverage various marketing channels to create impactful campaigns and promotions.
            </p>

            <h3>Key Responsibilities:</h3>
            <ul>
                <li>
                    <strong>Campaign Development:</strong> Assist in the planning, development, and execution of marketing campaigns
                    across various channels, including digital, social media, email, and traditional marketing.
                </li>
                <li>
                    <strong>Content Creation:</strong> Create engaging and persuasive content for marketing materials, including
                    website copy, blog posts, social media posts, and email newsletters.
                </li>
                <li>
                    <strong>Digital Marketing:</strong> Manage digital marketing efforts, including SEO, SEM, social media
                    advertising, and email marketing campaigns.
                </li>
                <li>
                    <strong>Market Research:</strong> Conduct market research and competitor analysis to identify trends, customer
                    preferences, and opportunities for growth.
                </li>
                <li>
                    <strong>Customer Engagement:</strong> Build and maintain relationships with customers, responding to inquiries,
                    gathering feedback, and providing excellent customer service.
                </li>
                <li>
                    <strong>Analytics and Reporting:</strong> Monitor and analyze the performance of marketing campaigns, providing
                    insights and recommendations for improvement.
                </li>
                <li>
                    <strong>Branding:</strong> Ensure consistency in brand messaging and visual identity across all marketing
                    materials.
                </li>
                <li>
                    <strong>Budget Management:</strong> Assist in managing the marketing budget, ensuring cost-effective use of
                    resources.
                </li>
            </ul>

            <h3>Qualifications:</h3>
            <ul>
                <li>Bachelor's degree in Marketing, Business, or a related field.</li>
                <li>Proven experience in marketing, preferably in a similar role.</li>
                <li>Strong written and verbal communication skills.</li>
                <li>Creative thinking and ability to generate fresh marketing ideas.</li>
                <li>Proficiency in digital marketing tools and platforms.</li>
                <li>Analytical mindset with the ability to interpret data and make data-driven decisions.</li>
                <li>Strong project management and organizational skills.</li>
                <li>Excellent attention to detail.</li>
            </ul>

            <h3>Why [Company Name]?</h3>
            <ul>
                <li>Opportunity to work in a dynamic and innovative [industry/sector] company.</li>
                <li>Competitive salary and benefits package.</li>
                <li>Collaborative and inclusive work environment.</li>
                <li>Opportunities for professional development and growth.</li>
            </ul>

            <p>
                If you are a passionate marketer with a desire to contribute to our company's growth and success, we invite you to
                apply for the position of Marketing Executive at [Company Name]. Join us in creating and implementing marketing
                strategies that make a meaningful impact.
            </p>
    `,
        },
        createdAt: new Date(),
        geo: [-0.7594171, 52.0406224],
        location: "Milton Keynes",
        locationLabel: "Milton Keynes",
        locationMeta: {
            address_components: [
                {
                    long_name: "Milton Keynes",
                    short_name: "Milton Keynes",
                    types: ["locality", "political"],
                },
                {
                    long_name: "Milton Keynes",
                    short_name: "Milton Keynes",
                    types: ["postal_town"],
                },
                {
                    long_name: "Milton Keynes",
                    short_name: "Milton Keynes",
                    types: ["administrative_area_level_2", "political"],
                },
                {
                    long_name: "England",
                    short_name: "England",
                    types: ["administrative_area_level_1", "political"],
                },
                {
                    long_name: "United Kingdom",
                    short_name: "GB",
                    types: ["country", "political"],
                },
            ],
            formatted_address: "Milton Keynes, UK",
            place_id: "ChIJhYYjgvhMdkgRFH65TPedGhY",
        },
        published: true,
        reference: "JOB-2",
        showOnGoogleJobs: true,
        slug: "ecc8a827-f0d5-45f1-8364-ac21a7be228f-test-marketing-job",
        tags: ["marketing"],
        title: "Marketing Executive",
        type: "Full Time",
        updatedAt: new Date(),
        salary: {
            type: "Annual",
            from: 30000,
            to: 40000,
            currency: "GBP",
        },
    },
    {
        active: true,
        archived: false,
        businessUnit: "Product",
        category: "Engineering",
        remote: "remote",
        categorySlug: "engineering",
        summary: {
            en: "A short summary of the role to provide a brief overview for preview links and search results.",
        },
        content: {
            en: `
            <p>
                As a Vehicle Technician at [Company Name], you will play a crucial role in ensuring the safety, reliability, and
                performance of our customers' vehicles.</p>
            <p>You'll work with a team of experienced technicians and have access to
                state-of-the-art equipment to diagnose and repair a wide range of automotive issues. This role offers an opportunity
                for professional growth and development in the automotive industry.
            </p>
            <h2>Key Responsibilities:</h2>
            <ul>
                <li>
                    <strong>Vehicle Maintenance:</strong> Perform routine maintenance tasks such as oil changes, tire rotations, and brake
                    inspections to keep vehicles in optimal condition.
                </li>
                <li>
                    <strong>Diagnosis and Repairs:</strong> Diagnose and repair mechanical, electrical, and electronic issues in vehicles, including
                    engines, transmissions, brakes, suspension, and more.
                </li>
                <li>
                    <strong>Inspections:</strong> Conduct thorough vehicle inspections to identify and document any potential problems or safety
                    concerns.
                </li>
                <li>
                    <strong>Parts Replacement:</strong> Replace worn or damaged parts, ensuring the use of quality components and adhering to
                    manufacturer specifications.
                </li>
                <li>
                    <strong>Diagnostic Tools:</strong> Utilize diagnostic tools and equipment to accurately identify and resolve vehicle issues.
                </li>
                <li>
                    <strong>Customer Communication:</strong> Communicate with customers to explain repair recommendations, provide estimates, and
                    address questions or concerns.
                </li>
                <li>
                    <strong>Safety Compliance:</strong> Ensure all work is performed in compliance with safety standards and regulations.
                </li>
                <li>
                    <strong>Documentation:</strong> Maintain accurate records of all maintenance and repair work performed on vehicles.
                </li>
                <li>
                    <strong>Continued Learning:</strong> Stay updated on automotive technology and industry trends through training and self-study.
                </li>
            </ul>
            <h2>Qualifications:</h2>
            <ul>
                <li>High school diploma or equivalent; formal automotive training or certification is a plus.</li>
                <li>Proven experience as an automotive technician, with a strong understanding of vehicle systems and components.</li>
                <li>Proficiency in using diagnostic tools and equipment.</li>
                <li>Strong problem-solving and troubleshooting skills.</li>
                <li>Excellent attention to detail and a commitment to quality workmanship.</li>
                <li>Effective communication skills, both with team members and customers.</li>
                <li>Physical fitness and manual dexterity to perform tasks in various weather conditions.</li>
                <li>Valid driver's license and a clean driving record.</li>
            </ul>
            <h2>Why [Company Name]?</h2>
            <ul>
                <li>Competitive salary and performance-based incentives.</li>
                <li>Opportunities for training, advancement, and professional development.</li>
                <li>Supportive and collaborative work environment.</li>
                <li>Access to the latest automotive technology and tools.</li>
            </ul>
            <p>
                If you have a passion for automotive repair and maintenance and want to join a team dedicated to providing top-notch
                service to our customers, we encourage you to apply for the position of Vehicle Technician at [Company Name]. Help us
                keep vehicles running safely and efficiently.
            </p>
        `,
        },
        createdAt: new Date(),
        geo: [-9.1393366, 38.7222524],
        location: "Lisbon",
        locationLabel: "Lisbon",
        locationMeta: {
            address_components: [
                {
                    long_name: "Lisbon",
                    short_name: "Lisbon",
                    types: ["locality", "political"],
                },
                {
                    long_name: "Lisbon",
                    short_name: "Lisbon",
                    types: ["administrative_area_level_2", "political"],
                },
                {
                    long_name: "Lisbon",
                    short_name: "Lisbon",
                    types: ["administrative_area_level_1", "political"],
                },
                {
                    long_name: "Portugal",
                    short_name: "PT",
                    types: ["country", "political"],
                },
            ],
            formatted_address: "Lisbon, Portugal",
            place_id: "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",
        },
        published: true,
        reference: null,
        salary: {
            type: "Hourly",
            from: 60,
            to: 70,
            currency: "EUR",
        },
        showOnGoogleJobs: true,
        slug: "de3c357a-43b1-4938-b9b5-276bd4abe3f1-test-engineering-job",
        tags: ["engineering", "lisbon"],
        title: "Software Engineer",
        type: "Contract",
        updatedAt: new Date(),
    },
    {
        active: true,
        archived: false,
        businessUnit: "Technology",
        category: "Software Development",
        remote: "remote",
        categorySlug: "software-development",
        summary: {
            en: "A short summary of the role to provide a brief overview for preview links and search results.",
        },
        content: {
            en: `<h3>Position Overview:</h3>
            <p>
                As a Software Developer at [Company Name], you will be instrumental in developing innovative software solutions that
                drive our business forward. You'll collaborate with a dynamic team of developers, designers, and product managers to
                create and improve web and mobile applications. This role is an exciting opportunity to grow your software development
                skills and make a significant impact in a fast-paced, technology-driven environment.
            </p>
            <h3>Key Responsibilities:</h3>
            <ul>
                <li>Software Development: Design, develop, and implement software applications according to specifications.</li>
                <li>Code Review: Conduct code reviews to ensure high-quality software development standards.</li>
                <li>Problem Solving: Troubleshoot and resolve software issues and bugs.</li>
                <li>Collaboration: Work closely with team members and stakeholders to ensure alignment on project goals and timelines.</li>
                <li>Continuous Learning: Keep up-to-date with the latest software development technologies and methodologies.</li>
            </ul>
            <h3>Qualifications:</h3>
            <ul>
                <li>Bachelor's degree in Computer Science, Engineering, or a related field.</li>
                <li>Experience with programming languages such as Java, C#, Python, or JavaScript.</li>
                <li>Familiarity with web development technologies (HTML, CSS, JavaScript, React, Angular, etc.) and database management.</li>
                <li>Strong analytical and problem-solving skills.</li>
                <li>Excellent communication and teamwork abilities.</li>
                <li>Proven ability to manage multiple tasks or projects with attention to detail.</li>
            </ul>
            <h3>Why [Company Name]?</h3>
            <p>
                We offer a competitive salary, flexible working conditions, and the opportunity to work on exciting and innovative
                projects. Join us to be part of a culture that values creativity, innovation, and diversity.
            </p>
            `,
        },
        createdAt: new Date(),
        geo: [-9.1393366, 38.7222524],
        location: "Lisbon",
        locationLabel: "Lisbon",
        locationMeta: {
            address_components: [
                {
                    long_name: "Lisbon",
                    short_name: "Lisbon",
                    types: ["locality", "political"],
                },
                {
                    long_name: "Lisbon",
                    short_name: "Lisbon",
                    types: ["administrative_area_level_2", "political"],
                },
                {
                    long_name: "Lisbon",
                    short_name: "Lisbon",
                    types: ["administrative_area_level_1", "political"],
                },
                {
                    long_name: "Portugal",
                    short_name: "PT",
                    types: ["country", "political"],
                },
            ],
            formatted_address: "Lisbon, Portugal",
            place_id: "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",
        },
        published: true,
        reference: null,
        salary: {
            type: "Salary",
            from: 30000,
            to: 50000,
            currency: "EUR",
        },
        showOnGoogleJobs: true,
        slug: "unique-identifier-for-software-developer-position",
        tags: ["software development", "lisbon"],
        title: "UI Developer",
        type: "Full-time",
        updatedAt: new Date(),
    },
    {
        active: true,
        archived: false,
        businessUnit: "Sales",
        category: "Retail",
        remote: "no",
        categorySlug: "retail",
        summary: {
            en: "A short summary of the role to provide a brief overview for preview links and search results.",
        },
        content: {
            en: `<h3>Position Overview:</h3>
            <p>
                As a Sales Assistant at [Company Name], you will be at the forefront of our mission to provide exceptional customer
                service and support our sales team. Located in London, you'll engage with customers, helping to find the products they
                love and provide a memorable shopping experience. This role is perfect for someone passionate about retail, sales, and
                working in a fast-paced, dynamic environment.
            </p>

            <h3>Key Responsibilities:</h3>
            <ul>
                <li>
                    <strong>Customer Service:</strong> Greet customers, answer questions, and provide assistance to ensure a positive shopping
                    experience.
                </li>
                <li>
                    <strong>Sales Support:</strong> Assist in achieving sales targets through effective customer engagement and product knowledge.
                </li>
                <li>
                    <strong>Product Knowledge:</strong> Maintain up-to-date knowledge of products, promotions, and store layout to efficiently
                    assist customers.
                </li>
                <li>
                    <strong>Stock Management:</strong> Help with stock replenishment, inventory checks, and maintaining the store's presentation
                    standards.
                </li>
                <li>
                    <strong>Cash Handling:</strong> Process sales transactions accurately and responsibly at the cash register.
                </li>
                <li>
                    <strong>Team Collaboration:</strong> Work collaboratively with the sales team to meet goals and support store operations.
                </li>
            </ul>

            <h3>Qualifications:</h3>
            <ul>
                <li>High school diploma or equivalent; previous experience in retail or sales is highly desirable.</li>
                <li>Excellent communication skills and a friendly, approachable personality.</li>
                <li>Ability to work flexibly, including weekends and evenings as required.</li>
                <li>Strong organizational skills and attention to detail.</li>
                <li>Enthusiasm for learning about new products and engaging with customers.</li>
            </ul>

            <h3>Why [Company Name]?</h3>
            <p>
                Join us and be part of a vibrant team in the heart of London. We offer a competitive salary, staff discounts, and the
                opportunity for professional growth in a supportive and dynamic environment.
            </p>
            `,
        },
        createdAt: new Date(),
        geo: [-0.127758, 51.507351],
        location: "London",
        locationLabel: "London",
        locationMeta: {
            address_components: [
                {
                    long_name: "London",
                    short_name: "London",
                    types: ["locality", "political"],
                },
                {
                    long_name: "London",
                    short_name: "London",
                    types: ["administrative_area_level_2", "political"],
                },
                {
                    long_name: "England",
                    short_name: "ENG",
                    types: ["administrative_area_level_1", "political"],
                },
                {
                    long_name: "United Kingdom",
                    short_name: "GB",
                    types: ["country", "political"],
                },
            ],
            formatted_address: "London, United Kingdom",
            place_id: "ChIJdd4hrwug2EcRmSrV3Vo6llI",
        },
        published: true,
        reference: null,
        salary: {
            type: "Hourly",
            from: 10,
            to: 15,
            currency: "GBP",
        },
        showOnGoogleJobs: true,
        slug: "unique-identifier-for-sales-assistant-position",
        tags: ["retail", "london", "sales"],
        title: "Sales Assistant",
        type: "Part-time",
        updatedAt: new Date(),
    },
];

export const DummyJob = jobs[0];

export const DummyPage = {
    title: "Example Page",
    slug: "example-page",
    published: true,
    createdAt: new Date(),
    updatedAt: new Date(),
};

export const getDummyJobs = (count = 10) => {
    // Guard again this number being a string
    if(typeof count === "string") {
        count = parseInt(count);
    }
    const data = [...new Array(count)].map((item, i) => {
        // Randomly select a job from the list of jobs
        return jobs[i % jobs.length];
    });

    return {
        total: 30,
        data,
    };
};
